import PropTypes from 'prop-types';
import './speakers.css';
import Logo from './logo.png';

export const Speaker = ({ speaker, handleClick }) => {
  return (
    <div className="snn-speaker-card" onClick={handleClick}>
      <div className="snn-speaker-card-photo-wrapper">
        <img
          className="snn-speaker-card-photo"
          src={speaker.img}
          alt={speaker.name}
          loading="lazy"
        />
      </div>
      <img className="snn-speaker-card-badge" src={Logo} alt="" />
      <div className="snn-speaker-card-info">
        <h2 className="snn-speaker-card-name">{speaker.name}</h2>
        {speaker.logo ? (
          <div className="snn-speaker-card-logo-wrapper">
            <img src={speaker.logo} alt="" />
          </div>
        ) : null}
        <p className="snn-speaker-card-affiliation">{speaker.affiliation}</p>
      </div>
    </div>
  );
};

Speaker.propTypes = {
  speaker: PropTypes.any,
  handleClick: PropTypes.func,
};
